<template>
  <MainMenu :isShop="shop" :primaryLinks="primaryLinks" :secondaryLinks="secondaryLinks" />
</template>

<script>
import MainMenu from "../../components/MainMenu/MainMenu.vue";

export default {
  name: "app",
  components: {
    MainMenu
  },
  data() {
    return {
      shop: this.$options._parentVnode.data.props.shop,
      primaryLinks: JSON.parse(this.$options._parentVnode.data.props.primaryNav),
      secondaryLinks: JSON.parse(this.$options._parentVnode.data.props.secondaryNav)
    };
  }
};
</script>
